import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const SocialMediaXing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M10.386 9.944l-3.108 5.514c-.218.371-.48.557-.786.557h-2.89a.405.405 0 01-.375-.206.424.424 0 010-.435l3.06-5.418c.007 0 .007-.004 0-.012L4.34 6.571c-.097-.178-.101-.327-.013-.448.073-.12.202-.181.387-.181h2.89c.323 0 .589.181.798.544l1.984 3.458zm9.746-7.763c.088.13.088.278 0 .448l-6.385 11.294v.012l4.063 7.436c.089.161.093.31.012.448-.08.12-.21.181-.387.181h-2.89c-.338 0-.604-.181-.798-.544l-4.1-7.521 6.422-11.39c.201-.364.46-.545.774-.545h2.914c.177 0 .302.06.375.181z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
